var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.75 3.25C8.75 3.97935 8.46027 4.67882 7.94454 5.19454C7.42882 5.71027 6.72935 6 6 6C5.27065 6 4.57118 5.71027 4.05546 5.19454C3.53973 4.67882 3.25 3.97935 3.25 3.25C3.25 2.52065 3.53973 1.82118 4.05546 1.30546C4.57118 0.789731 5.27065 0.5 6 0.5C6.72935 0.5 7.42882 0.789731 7.94454 1.30546C8.46027 1.82118 8.75 2.52065 8.75 3.25ZM1.5 10C1.5 8.35 2.85 7 4.5 7H7.5C9.15 7 10.5 8.35 10.5 10V11.5H1.5V10Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/user_icon.743cb412517feb0b97edc6210944ca21.svg";
export { ForwardRef as ReactComponent };